import React, {useEffect, useState} from 'react';

import {useCurrentUserState} from 'app/current-user/api';
import {useSlimTasks} from 'app/tasks/api';
import {VeryCompactTaskItem} from 'app/tasks/components/TasksDashboard/VeryCompactTaskItem';
import {getStartEndIntervalFromParams} from 'app/tasks/interval-filter';
import {ACTION_CENTER_PAGE_SIZE} from 'app/utils/constants';
import {gt} from 'app/utils/i18n';

import {DashboardListWidget} from './DashboardListWidget';

import type {TaskDashboardLocationParamsType} from 'app/tasks/types';

export function RecentTasksWidget() {
  const {timezone: userTimezone, url: userUrl} = useCurrentUserState().data!;

  function generateLocationParams(): TaskDashboardLocationParamsType {
    return {
      page_size: ACTION_CENTER_PAGE_SIZE,
      ...getStartEndIntervalFromParams({interval: 'this-week'}, userTimezone),
      user: userUrl,
      completed: 'false',
    };
  }

  const [widgetParams, setWidgetParams] =
    useState<TaskDashboardLocationParamsType>(generateLocationParams());

  useEffect(() => {
    setWidgetParams(() => {
      return generateLocationParams();
    });
  }, [userTimezone, userUrl]);

  return (
    <DashboardListWidget
      icon="fa fa-tasks"
      title={gt('Tasks Due This Week')}
      hook={useSlimTasks}
      params={widgetParams}
      emptyMessage={gt('No Tasks Due')}
      renderItem={(task) => <VeryCompactTaskItem task={task} />}
    />
  );
}
